import { Component } from '@angular/core';
import { CardItemComponent } from '../../UI/card-item/card-item.component';
@Component({
  selector: 'app-static-card-note',
  imports: [CardItemComponent],
  templateUrl: './static-card-note.component.html',
  styleUrl: './static-card-note.component.css'
})
export class StaticCardNoteComponent {
  cardItems: any[] =
    [
      {
        icon: 'Images/card1.jpg',
        name: '1. Start With the Basics',
        discrption: 'Begin each topic by reading the summary and key definitions. This builds a strong foundation before you dive deeper.'
      }
      ,
      {
        icon: 'Images/card2.jpg',
        name: '2. Apply What You Learn',
        discrption: 'Use the examples and examiner tips to connect ideas and understand how they appear in actual exam questions.'
      },
      {
        icon: 'Images/card3.jpg',

        name: '3. Review and Reinforce',
        discrption: 'Revisit notes regularly and pair them with flashcards or past papers to strengthen memory and boost long-term retention.'
      }
    ]
}
